import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import Dropdown from 'af-components/Controls/Dropdown';

import * as EquipmentActions from 'af-actions/equipment';

import styles from './styles.module.scss';

export interface EquipmentFilterOption {
	id: number;
	label: string;
}

interface OwnProps {
	onChange: (option: Nullable<EquipmentFilterOption>) => void;
	startDate: Date;
	endDate: Date;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const EquipmentFilter: React.FC<Props> = (props) => {

	const {
		onChange,
		findAll,
		startDate,
		endDate,
	} = props;

	const [options, setOptions] = React.useState<EquipmentFilterOption[]>([]);

	const fetchOptions = React.useCallback(async () => {
		const _options = await findAll(
			TimeUtils.formatDate(startDate, TimeFormat.DB_DATE_ONLY, TimeFormat.ISO_DATETIME),
			TimeUtils.formatDate(endDate, TimeFormat.DB_DATE_ONLY, TimeFormat.ISO_DATETIME)
		);
		const formattedOptions = _options.equipments.map((option) => ({ id: option.id, label: `${option.code} ${option.specification ? `(${option.specification})` : ''}` }));
		setOptions(formattedOptions);
	}, [findAll, startDate, endDate]);

	React.useEffect(() => {
		fetchOptions();
	}, [fetchOptions]);

	const renderOption = React.useCallback((option: EquipmentFilterOption) => {
		return (
			<>
				{option.label}
			</>
		);
	}, []);

	const filterBy = React.useCallback((option: EquipmentFilterOption, rawInput: string) => {
		return option.label.toLowerCase().includes(rawInput.toLowerCase());
	}, []);

	return (
		<div className={styles.dropdown}>
			<Dropdown<EquipmentFilterOption>
				filterable={true}
				filterBy={filterBy}
				hasBlankOption={true}
				labelKey={'label'}
				onValueChange={onChange}
				options={options}
				placeholder="Select Equipment"
				renderMenuItem={renderOption}
				valueKey={'id'}
				withCaret={true}
			/>
		</div>
	);
};

function mapDispatchToProps() {
	return {
		findAll: EquipmentActions.findAllForOrderReportFilter,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(EquipmentFilter);
